import { Component } from '@angular/core';

@Component({
  selector: 'app-document-verification-form-wrapper',
  templateUrl: './document-verification-form-wrapper.component.html',
  styles: [],
  standalone: false,
})
export class DocumentVerificationFormWrapperComponent {}
